// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2GqmV","right":"styles_right__22Ica"};